import { createFileRoute } from '@tanstack/react-router';
import { RequireRole } from '../components/RequireRole';
import { StoresPage } from '../features/stores/StoresPage';

// Back-office seulement (réunion du 09/10/2026) : admin, RP, responsable
// back-office — jamais le manager. L'API applique la même règle.
export const Route = createFileRoute('/magasins')({
  component: () => (
    <RequireRole allow={['admin', 'responsable_partenaire', 'responsable_backoffice']}>
      <StoresPage />
    </RequireRole>
  ),
});
